export const cloneObj = (obj: any): any => {
    return JSON.parse(JSON.stringify(obj));
}